export function getAppraisalData(vehicles) {
  const { latestAppraisalRef, appraisalHistory } = vehicles;

  if (latestAppraisalRef) {
    const ref = latestAppraisalRef.split('/').splice(-1)[0];
    return appraisalHistory?.[ref];
  }
  return null;
}
